import { stackdPerpsPath } from 'common/routing/stackdPerpsPath';

export function getDebugChatApiPath() {
  return stackdPerpsPath('/api/debug-chat');
}
